import settings from '@settings';
import React from 'react';

const FlexBox: React.FC<FlexBoxProps> = ({
	children = '',
	direction = 'row',
	align = 'flex-start',
	justify = 'flex-start',
	gap = '0',
	wrap = false,
	changeToColumn = false,
	styles = {},
	hasFullWidth = false
}) => {
	const styledFlexBox = settings.mq({
		height: 'auto',
		padding: 0,
		display: 'flex',
		overflow: 'visible',
		position: 'relative',
		minWidth: 0,
		justifyContent: justify,
		alignItems: align,
		flexDirection: changeToColumn ? ['column', 'column', 'row', 'row'] : direction,
		width: hasFullWidth ? '100%' : 'auto',
		gap,
		flexWrap: wrap ? 'wrap' : 'no-wrap',
		...styles
	});

	return (
		<div css={styledFlexBox}>
			{children}
		</div>
	);
};

type FlexBoxProps = {
	children: React.ReactNode,
	direction?: string,
	align?: string,
	justify?: string,
	gap?: string,
	wrap?: boolean,
	changeToColumn?: boolean,
	hasFullWidth?: boolean,
	styles?: object
}

export default FlexBox;